import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../../styles/utils/fill";
import { classNames } from "../../../../utils";
export const ProgressActivity = t0 => {
  const $ = _c(15);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      size: t1,
      fill: t2,
      fillAttribute: t3,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== className || $[7] !== fill) {
    t4 = classNames(fillVariants({
      fill
    }), "animate-spin", className);
    $[6] = className;
    $[7] = fill;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="M480-71.87q-83.91 0-158.34-32.12-74.43-32.11-129.99-87.68-55.57-55.56-87.68-129.99Q71.87-396.09 71.87-480q0-84.71 32.11-158.7 32.12-73.99 87.68-129.61 55.56-55.62 129.99-87.72 74.44-32.1 158.35-32.1 19.15 0 32.33 13.17 13.17 13.18 13.17 32.33t-13.17 32.33q-13.18 13.17-32.33 13.17-131.81 0-224.47 92.66T162.87-480q0 131.8 92.66 224.47 92.66 92.66 224.47 92.66 131.8 0 224.47-92.66 92.66-92.66 92.66-224.47 0-19.15 13.17-32.33 13.18-13.17 32.33-13.17t32.33 13.17q13.17 13.18 13.17 32.33 0 83.91-32.11 158.35-32.12 74.44-87.68 130.01-55.56 55.57-129.58 87.67-74.02 32.1-158.76 32.1Z" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== rest || $[12] !== size || $[13] !== t4) {
    t6 = <svg aria-label="Progress Activity" className={t4} fill={fillAttribute} height={size} role="img" viewBox="0 -960 960 960" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t5}</svg>;
    $[10] = fillAttribute;
    $[11] = rest;
    $[12] = size;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};